module.exports = __webpack_public_path__ + "static/media/addSchool.69ef24fe.JPG";